export class Organization {
  name: string;
  url: URL;
  avatar?: string;
  id: string;
  ssoIsMandatory: boolean;
  identityProviderName: string;

  constructor({
    name,
    url,
    avatar,
    id: organizationId,
    ssoIsMandatory,
    identityProviderName
  }: OrganizationData) {
    this.name = name;
    this.url = url;
    this.avatar = avatar;
    this.id = organizationId;
    this.ssoIsMandatory = ssoIsMandatory;
    this.identityProviderName = identityProviderName;
  }
}

export interface OrganizationData {
  name: string;
  url: URL;
  avatar?: string;
  id: string;
  ssoIsMandatory: boolean;
  identityProviderName: string;
}
